import { faPlus, faPercent } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './RatesIsEmpty.module.scss';
import Button from 'components/UI/V3/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface RatesIsEmptyProps {
    title: string;
    text: string;
    showButton?: boolean;
    onClick?: () => void;
    className?: string;
}

const RatesIsEmpty: FunctionComponent<RatesIsEmptyProps> = props => {
    return (
        <div className={clsx(styles.baseContainer, props.className)}>
            <div className={styles.wrapper}>
                <div className={clsx(styles.icon)}>
                    <FontAwesomeIcon
                        icon={faPercent}
                        aria-hidden="true"
                    />
                </div>
                <h1 className={clsx(styles.title)}>{props.title}</h1>
                <p className={clsx(styles.paragraph)}>{props.text}</p>

                {props.showButton && (
                    <div className={styles.buttonContainer}>
                        <Button
                            label="Add Rate"
                            size="large"
                            variant="primary"
                            leftIcon={faPlus}
                            onClick={props.onClick}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default RatesIsEmpty;
